import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodigoLancamentoComponent } from './codigo-lancamento.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { CodigoLancamentoEditComponent } from './codigo-lancamento-edit/codigo-lancamento-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [CodigoLancamentoComponent, CodigoLancamentoEditComponent]
})
export class CodigoLancamentoModule { }
